const milestones = [
  { year: '2015', title: '平台创立', description: '彩客网正式上线，提供双色球和大乐透基础数据查询服务' },
  { year: '2016', title: '彩种拓展', description: '新增福彩3D、排列三、七星彩等主流彩种，覆盖更多用户需求' },
  { year: '2017', title: '百万用户', description: '注册用户突破100万，成为彩票数据服务领域的知名品牌' },
  { year: '2019', title: '智能升级', description: '推出AI智能预测分析功能，引领行业技术创新方向' },
  { year: '2021', title: '五百万用户', description: '注册用户突破500万，日均访问量超过200万次' },
  { year: '2024', title: '全新升级', description: '彩客网新版官网上线，全新界面设计和架构升级，体验更流畅' },
];

export default function MilestonesSection() {
  return (
    <section className="py-10 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center">
          发展历程
        </h2>
        <div className="relative mt-10 max-w-2xl mx-auto">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-primary-200 -translate-x-1/2"></div>
          {milestones.map((milestone, idx) => (
            <div
              key={idx}
              className={`relative flex items-start gap-6 mb-8 ${
                idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              }`}
            >
              <div className="absolute left-4 md:left-1/2 w-3 h-3 bg-primary-500 rounded-full -translate-x-1/2 mt-1.5 z-10 ring-4 ring-background-50"></div>
              <div className={`ml-12 md:ml-0 md:w-1/2 ${idx % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                  <span className="text-xs text-primary-600 font-bold bg-primary-100 px-3 py-1 rounded-full">
                    {milestone.year}
                  </span>
                  <h4 className="mt-2 text-sm font-semibold text-foreground-900">{milestone.title}</h4>
                  <p className="mt-1 text-xs text-foreground-500">{milestone.description}</p>
                </div>
              </div>
              <div className={`hidden md:block md:w-1/2 ${idx % 2 === 0 ? 'md:pl-12' : 'md:pr-12'}`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}